import React from "react";

// The agent app's PageLoader: centred on the screen, over everything.
export default function PilotLoader() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="flex flex-col items-center space-y-4 rounded-lg bg-surface p-8 text-darkergray">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-mediumgray border-t-darkgray" />
        <p className="text-sm font-medium tracking-wide text-darkergray">Loading...</p>
      </div>
    </div>
  );
}
